import {ChangeDetectorRef, Component, signal, WritableSignal} from '@angular/core';
import {ClaimFileUploads, FileUploadConfig, UploadingStatus} from '../../claim-file-uploads/claim-file-uploads';
import {ClaimFile, ClaimFileType, PresignedClaimFileUrlResponse} from '../../../entity/claim-file';
import {ClaimBatchService} from '../../../control/claim-batch-service';
import {NgClass} from '@angular/common';
import {BatchUploadMetadata} from '../../../entity/batch-upload';
import {SingleBatchUploadMetadata} from '../single-batch-upload-metadata/single-batch-upload-metadata.component';
import {LocalizationPipePipe} from '../../../../localization/control/localisation-pipe-pipe';

@Component({
  selector: 'app-batch-upload',
  imports: [ClaimFileUploads, NgClass, SingleBatchUploadMetadata, LocalizationPipePipe],
  templateUrl: './batch-upload.html',
  styleUrl: './batch-upload.scss'
})
export class BatchUpload {
  protected readonly batchUploadFilesConfig: FileUploadConfig = {
    title: 'Batch Upload Archive',
    subtitle: 'Please upload ZIP-Archive',
    icon: 'camera_alt',
    multiple: true,
    acceptedTypes: ['ZIP'],
    maxSize: 'max. 5GB per file',
    dropzoneText: 'Select file',
    optional: false,
    actionName: 'Upload and Submit',
    claimFileType: ClaimFileType.Others
  };
  readonly isUploadVisible = signal(true)
  protected batches: BatchUploadMetadata[] = []

  constructor(protected readonly claimBatchService: ClaimBatchService, private readonly cdr: ChangeDetectorRef) {
  }

  protected getBatchUploadPresignedUrls(_: string, __: ClaimFileType, claimFiles: ClaimFile[]): Promise<PresignedClaimFileUrlResponse> {
    return this.claimBatchService.getBatchUploadPresignedUrls(claimFiles)
  }

  protected showUploadClicked() {
    this.isUploadVisible.set(true)
  }

  protected showListClicked() {
    this.claimBatchService.getAllBatchUploads()
      .then(r => this.batches = [...r])
      .then(() => this.isUploadVisible.set(false))
      .then(() => this.cdr.detectChanges())
  }

  protected onBatchUploadFilesUploading($event: UploadingStatus) {
    console.log("onBatchUploadFilesUploading ", $event)
    if ($event.status === 'completed') {
      this.showListClicked()
      alert("Batch upload completed")
    }
  }
}
